module.exports = __webpack_public_path__ + "static/img/son4.2baa1c1a.png";